import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import SalesStatisticsItem from '../entities/sales-statistics-item'
import Ajax from '../../lib/ajax'
import PageResult from '../entities/page-result';
import AppConsts from '@/lib/appconst'
interface SalesStatisticsState extends ListState<SalesStatisticsItem> {
}
class SalesStatisticsModule extends ListModule<SalesStatisticsState, any, SalesStatisticsItem>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: AppConsts.pageSize,
        list: new Array<SalesStatisticsItem>(),
        loading: false
    }
    actions = {
        async getAll(context: ActionContext<SalesStatisticsState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/ViewSaleOrder/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<SalesStatisticsItem>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        }
    };
    mutations = {
        setCurrentPage(state: SalesStatisticsState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: SalesStatisticsState, pagesize: number) {
            state.pageSize = pagesize;
        },
        refreshListData(state: SalesStatisticsState)
        {
            state.list = new Array<SalesStatisticsItem>();
        }
    }
}
const salesStatisticsModule = new SalesStatisticsModule();
export default salesStatisticsModule;